export default "__VITE_ASSET__fsWw9jiY__"